module.exports = __webpack_public_path__ + "img/img_xinshou_10.ddd6e52d.png";